import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationDialogComponent } from '@app/components';
import { FeatureFlag } from '@app/enums';
import { TimesheetEntry } from '@app/models/time-tracking/timesheet-entry.model';
import { MenuColumnEvent } from '@app/modules/table/interfaces/menu-column-event.interface';
import { MyTimesheetsIndexTable, TimeTrackingMenuService } from '@app/modules/time-tracking/services';
import { TimeTrackingSettingsService } from '@app/modules/time-tracking/services/time-tracking-settings.service';
import { AuthService, NotifyService } from '@app/services';
import { FeatureService } from '@app/services/feature.service';
import { PayrollIncomeType } from '@time-tracking/interfaces/settings.interface';

@Component({
    templateUrl: './my-timesheet-index.template.html',
})
export class MyTimesheetIndexView implements OnInit {
    @ViewChild('confirmDeleteModal') confirmDeleteModal!: ConfirmationDialogComponent;
    isLoading = true;
    table: MyTimesheetsIndexTable | undefined;
    hasTimeClock = false;

    constructor(
        public menuService: TimeTrackingMenuService,
        private notifyService: NotifyService,
        private router: Router,
        private route: ActivatedRoute,
        private auth: AuthService,
        private timeTrackingSettingsService: TimeTrackingSettingsService,
        private featureService: FeatureService
    ) {}

    async ngOnInit(): Promise<void> {
        let hasPayrollIntegration = false;
        let payrollIncomeTypes: PayrollIncomeType[] = [];
        const settings = await this.timeTrackingSettingsService.get();
        hasPayrollIntegration = settings.payrollIntegration ?? false;
        payrollIncomeTypes = settings.payrollIncomeTypes ?? [];

        this.hasTimeClock = await this.featureService.has(FeatureFlag.timeClock);
        this.table = new MyTimesheetsIndexTable(
            this.auth,
            hasPayrollIntegration,
            this.hasTimeClock,
            payrollIncomeTypes
        );
        this.table.reload();
        this.isLoading = false;
    }

    menuAction(event: MenuColumnEvent): void {
        const { menuItem, data } = event;

        const timesheetEntry = data as TimesheetEntry;

        switch (menuItem.event) {
            case 'edit':
                this.onEdit(timesheetEntry);
                break;
            case 'delete':
                this.deleteTimesheetEntry(timesheetEntry);
                break;
        }
    }

    async deleteTimesheetEntry(timesheetEntry: TimesheetEntry): Promise<void> {
        const shouldDelete = await this.confirmDeleteModal.open();
        if (!shouldDelete) {
            return;
        }

        try {
            await timesheetEntry.delete();
            this.table.reload();
        } catch (e) {
            this.notifyService.error('time-tracking.deleteErrorTimesheetEntry');
        }
    }

    onEdit(timesheetEntry: TimesheetEntry): void {
        this.router.navigate([timesheetEntry.id, 'edit'], { relativeTo: this.route });
    }
}
